export default {
  title: 'Organisation chart',
  description: 'Sites, the managers responsible for them, and the employees who report to each manager.',
  organisation: 'Organisation',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  expand: 'Expand',
  collapse: 'Collapse',
  admin: 'Admin',
  siteManager: 'Site manager',
  inactive: 'Inactive',
  emptyTitle: 'Nothing to show yet',
  emptyMessage: 'Add sites and employees to build the chart.',
  managersWithoutSite: 'Managers without a site',
  noManager: 'No manager assigned',
}
